import { Flex } from '@/src/ui-components';
import { cn } from '@/src/helpers';

// Title component for desktop
type TitleProps = {
  children: React.ReactNode;
  className?: string;
};

export const SignRightSideTitle = ({ children, className }: TitleProps) => {
  return (
    <Flex className={cn('lg:block lg:flex-col', className)}>{children}</Flex>
  );
};
